import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import { URLS } from 'bv360/utils/urls';

const pStyles = {
  fontSize: '1.2rem'
};

export default function(props) {
  const query = queryString.parse(props?.location?.search);
  const practiceAdmins = props?.location?.state?.practiceAdmins;

  const isMadeAdmin = query?.result === 'made_admin';

  return (
    <Container className="content--app">
      <h3>Thank you for registering!</h3>
      <br />
      <p style={pStyles}>
        {isMadeAdmin ? (
          <>
            You have been added as the first administrator for
            {query && query?.practice ? ` ${query.practice}` : ' your practice'}
            . You can now log in and manage your practice.
          </>
        ) : (
          <>
            You have successfully registered and requested access
            {query && query?.practice && query?.npi
              ? ` to practice NPI ${query.npi}, ${query.practice}`
              : null}
            ! Practice administrators have received and will process your request to join the practice.{' '}
          </>
        )}
      </p>
      {!isMadeAdmin && practiceAdmins && practiceAdmins.length > 0 && (
        <p style={pStyles}>
          You can contact the following practice administrators:
          <ul style={{ marginTop: '0.5rem' }}>
            {practiceAdmins.map((admin, idx) => (
              <li key={idx}>
                {admin.name ? `${admin.name} — ` : ''}
                <a href={`mailto:${admin.email}`}>{admin.email}</a>
              </li>
            ))}
          </ul>
        </p>
      )}
      <p style={pStyles}>
        Need help?{' '}
        <a href="tel:800-836-4080" className="link js-custom">
          Call us: 1-800-836-4080
        </a>
      </p>
      <p>
        <Link to={URLS.LOGIN} className="btn btn-primary btn--fw">
          Back
        </Link>
      </p>
    </Container>
  );
}
